import { get } from 'lodash'

class ContentfulFile {

    static default = {
        url: '',
        name: ''
    }

    static url = (contentfulFile) => get(contentfulFile, 'url', ContentfulFile.default.url)

    static fileName = (contentfulFile) => get(contentfulFile, 'name', ContentfulFile.default.name)
}

export default ContentfulFile;